export default {
  titles: {
    pickup: 'Odbiór',
    delivery: 'Dostawa',
  },
  buttons: {
    confirm: 'Potwierdź',
  },
};
